var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"current-page":_vm.pages+1,"page-sizes":[10, 20, 50, 100],"page-size":_vm.size,"layout":"total, sizes, prev, pager, next","total":_vm.totalSize},on:{"current-change":_vm.pageChange,"prev-click":_vm.pageChange,"next-click":_vm.pageChange,"size-change":_vm.pageSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }